export function redirectDatatransTransaction(transactionId: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const redirectBaseUrl = import.meta.env.VUE_APP_DATATRANS_REDIRECT_URL as string;

    if (!redirectBaseUrl) {
      reject(new Error('Datatrans redirect URL is not configured'));
      return;
    }

    const sanitizedBaseUrl = redirectBaseUrl.replace(/\/$/, '');
    const redirectUrl = `${sanitizedBaseUrl}/${transactionId}`;

    window.location.assign(redirectUrl);
    resolve();
  });
}
